<template>
  <div>

     <v-container>

         Loading ...
     </v-container>
  </div>
</template>
<script>
export default {
  name: 'TemporaryPage',
  data: function() {
    return {
        link: this.$route.params.link
    }
  },
  mounted() {
    setTimeout(()=>{
        this.movePage()
    },500);
  },
  methods: { 
    movePage() {
        this.$router.push(this.link); 
    }
  },
  created: {
    
  }
}
</script>